export default "__VITE_ASSET__BedNmt6s__"